var path = '/modules/contacts/views/pages/details/base.tpl.html';
var html = "<div class=\"contacts-details\">\n    <ui-view/>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/contacts/views/pages/details/base.tpl.html
// module id = 2071
// module chunks = 1